import { Column, defaultColActionDef, defaultColDef, TABLE_ACTION } from '@qrios/frontend-library';
import { predefinedColumns } from '../../../../../common/table/columns';

export const columns: Column[] = [
  {
    ...defaultColDef,
    field: 'emailAddress',
    headerName: 'Email address',
    flex: 1
  },
  {
    ...defaultColDef,
    field: 'role',
    headerName: 'User Role',
    flex: 1
  },
  predefinedColumns.status({ sortable: true }),
  predefinedColumns.date({ field: 'invitationDate', headerName: 'Invitation Date' }),
  predefinedColumns.date({ field: 'expirationDate', headerName: 'Expiration Date' }),
  {
    ...defaultColActionDef([TABLE_ACTION.RETRY, TABLE_ACTION.DELETE]),
    flex: 1
  }
];
